<template>
  <div class="mt-4 ml-3 d-flex justify-content-between">
    <span :class="{ hidden: !showText }" class="pagination-info">
      Mostrando {{ startIndex }} al {{ endIndex }} de {{ total }} resultados
    </span>
    <ul class="pagination mr-3 d-flex flex-wrap">
      <li class="mr-2  rounded bg-light-gray">
        <a
          :id="`${id}-GoToPrevious`"
          href="#"
          @click="goToPage(currentPage - 1)"
        >
          <i class="fa fa-chevron-left" />
        </a>
      </li>

      <li
        v-for="page in pages"
        :key="page"
        class="custom-border rounded border-top border-bottom"
      >
        <a
          :id="`${id}-GoToPage-${page}`"
          :class="{ active: page === currentPage }"
          href="#"
          @click="goToPage(page)"
        >
          {{ page }}
        </a>
      </li>

      <li class="ml-2  rounded">
        <a
          :id="`${id}-GoToNext`"
          class="bg-light-gray"
          href="#"
          @click="goToPage(currentPage + 1)"
        >
          <i class="fa fa-chevron-right" />
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.pagination-info {
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
.pagination {
  font: Bold 14px/17px Lato;
}
.pagination > li > a {
  width: 33px;
  height: 34px;
  position: relative;
  float: left;
  text-align: center;
  line-height: 34px;

  letter-spacing: 0;
  color: #11291b;
  text-decoration: none;
}
.pagination > ul > li {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}

.pagination > li a.active {
  background: #2db782 0% 0% no-repeat padding-box;
  color: white;
  border-radius: 4px;
}
.rounded {
  border-radius: 4px;
}

.custom-border {
  border: 1px solid #dee2e6 !important;
}
</style>

<script>
export default {
  name: 'Pagination',
  meta: {
    description: 'Indica contenido relacionado en varias páginas.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    id: {
      type: String,
      default: 'pgPager',
      meta: {
        description: 'Id del Componente de paginacion',
        example: 'pgPager',
      },
    },
    showText: {
      type: Boolean,
      required: false,
      default: true,
    },
    data: {
      type: Object,
      default() {
        return {
          currentPage: 0,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
        };
      },
      meta: {
        description: 'Establece la data relacionada al componente',
        example: '',
      },
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    pages() {
      const pages = [];
      const offset = 2;
      let endAt = 5;
      let startAt = 1;

      if (
        this.currentPage > 3 &&
        this.data.pageCount > this.currentPage + offset
      ) {
        endAt = this.currentPage + offset;
        startAt = this.currentPage - offset;
      }
      if (startAt < 0) startAt = 1;

      let qtyButtons = 0;

      if (this.data.pageCount <= endAt) {
        qtyButtons = this.data.pageCount;
      } else {
        qtyButtons = endAt;
      }

      for (let i = startAt; i <= qtyButtons; i++) {
        pages.push(i);
      }

      return pages;
    },
    total() {
      return this.data.totalItemCount;
    },
    startIndex() {
      // This is the correct, keep this on merge
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    endIndex() {
      // This is the correct, keep this on merge
      let limit = this.currentPage * this.pageSize;
      if (this.data.totalItemCount > limit) {
        return limit;
      } else {
        return this.data.totalItemCount;
      }
    },
    currentPage() {
      return this.data.currentPage;
    },
  },
  methods: {
    goToPage(pageNumber) {
      if (pageNumber < 1 || pageNumber > this.data.pageCount) return;
      if (pageNumber !== this.currentPage) {
        this.$emit('pagination-go-page', pageNumber);
      }
    },
  },
};
</script>
